module.exports = {"data":{"allBlogJson":null,"authorJson":{"name":"Code Fellows","slug":"blog/author/code-fellows","twitter":null,"linkedIn":null,"website":null,"biography":null,"image":null}},"pathContext":{"slug":"blog/author/code-fellows"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/blog-author-code-fellows.json
// module id = 1329
// module chunks = 221384710756650